export default __webpack_public_path__ + "static/media/sand_clock_animation.d93ebe98.gif";